export const environment = {
  production: true,
  api_url: 'https://backend.codehospitality.co.uk/admin/',
  new_admin_url: 'https://admin.codehospitality.co.uk',
  stripe_dashboard_test_mode: false
};



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/environments/environment.ts